import React, {
  useEffect,
  useState
} from "react";

import {
  collection,
  getDocs,
  getCountFromServer,
  query,
  where,
  writeBatch,
  doc,
  serverTimestamp,
  runTransaction,
} from "firebase/firestore";

import {
  useNavigate
} from "react-router-dom";

import { db } from "../../firebase";

export default function ProcurementQueue() {

  const navigate =
    useNavigate();

    const userData =
  JSON.parse(
    localStorage.getItem(
      "user"
    ) || "{}"
  );

  const [
    queueItems,
    setQueueItems
  ] = useState([]);

  const [
  materialRequestDocs,
  setMaterialRequestDocs
] = useState([]);

  const [
    // eslint-disable-next-line no-unused-vars
    loading,
    setLoading
  ] = useState(true);

  const [
  selectedItems,
  setSelectedItems
] = useState({});

const [
  generatingBatch,
  setGeneratingBatch
] = useState(false);

// vendor per row: { procurement_row_id: { vendor_id, vendor_name } }
const [selectedVendors, setSelectedVendors] = useState({});
const [vendorsList, setVendorsList]         = useState([]);

// ============================================
// FILTERED / VISIBLE QUEUE ITEMS
// ============================================

const filteredQueueItems =

  Object.values(

    queueItems.reduce(

      (acc, row) => {

        // CUSTOM ITEMS
        // NEVER MERGE

        if (
          row.is_custom_item ||
          !row.item_id
        ) {

          acc[
            `custom_${row.mrf_id}_${row.item_index}`
          ] = {

            ...row,

            total_remaining:
              Number(row.remaining_qty || 0),

            total_approved:
              Number(row.approved_qty || 0),

            total_issued:
              Number(row.issued_qty || 0)
          };

          return acc;
        }

        // NORMAL ITEMS
        // MERGE SAME INVENTORY ITEMS

        const key =
          `${row.item_id}_${row.unit}`;

        if (!acc[key]) {

          acc[key] = {

            ...row,

            total_remaining:
              Number(row.remaining_qty || 0),

            total_approved:
              Number(row.approved_qty || 0),

            total_issued:
              Number(row.issued_qty || 0)
          };

        } else {

          acc[key].total_remaining +=
            Number(row.remaining_qty || 0);

          acc[key].total_approved +=
            Number(row.approved_qty || 0);

          acc[key].total_issued +=
            Number(row.issued_qty || 0);
        }

        return acc;

      },

      {}

    )

  );

  // ============================================
  // LOAD APPROVED UNPROCESSED PROCUREMENT ITEMS
  // ============================================

  const fetchQueue = async () => {
    try {
      setLoading(true);

      const companyId = userData.company_id || "";

      // ── STEP 1: Fetch all approved/partially_issued MRFs (1 query) ──
      const mrfSnap = await getDocs(query(
        collection(db, "material_requests"),
        where("company_id", "==", companyId),
        where("status", "in", ["approved", "partially_issued"])
      ));
      setMaterialRequestDocs(mrfSnap.docs);

      // ── STEP 2: Collect ALL unique item_ids from all MRFs ──
      

      // ── STEP 3: Fetch ALL items master in ONE query ──
      // Build 4-key lookup map: by item_id, by doc id, by item_code, by name
      const itemsMasterMap = {};
      const itemsSnap = await getDocs(query(
        collection(db, "items"),
        where("company_id", "in", [companyId, ""])
      ));
      // NEW — inactive items excluded from master map entirely
itemsSnap.forEach(d => {
  const item = d.data();
  if (item.is_active === false) return;                  // ← NEW
  const byId   = (item.item_id   || "").trim();
  const byCode = (item.item_code || "").trim();
  const byName = (item.item_name || "").toLowerCase().trim();
  const byDoc  = d.id;
  if (byId)   itemsMasterMap[byId]             = item;
  if (byCode) itemsMasterMap[byCode]            = item;
  if (byName) itemsMasterMap[`name:${byName}`]  = item;
  if (byDoc)  itemsMasterMap[byDoc]             = item;
});

      // ── STEP 4: Fetch ALL inventory_summary in ONE query ──
      // Build lookup map by item_id + item_code
      const inventoryMap = {};
      const invSnap = await getDocs(query(
        collection(db, "inventory_summary"),
        where("company_id", "==", companyId)
      ));
      invSnap.forEach(d => {
        const inv = d.data();
        if (inv.item_id)   inventoryMap[inv.item_id]   = inv;
        if (inv.item_code) inventoryMap[inv.item_code] = inv;
        inventoryMap[d.id] = inv; // doc ID fallback
      });

      // ── STEP 5: Fetch vendors in ONE query ──
      const vendorsMap = {};
      const vendorsSnap = await getDocs(query(
        collection(db, "vendors"),
        where("company_id", "==", companyId)
      ));
      const vendorsList = vendorsSnap.docs.map(d => ({ id: d.id, ...d.data() }));
      vendorsList.forEach(v => { vendorsMap[v.id] = v; });

      // ── STEP 6: Process everything in memory — zero per-item queries ──
      const rows = [];

      for (const docSnap of mrfSnap.docs) {
        const data = docSnap.data();

        for (const [itemIndex, item] of (data.items || []).entries()) {

          // Procurement type filter
          const procurementType = String(
            item.procurement_type || item.procurement || "purchase"
          ).toLowerCase();
          if (procurementType !== "purchase") continue;

          // Skip already batched
          if (["batched", "po_created"].includes(item.purchase_status)) continue;

          // ✅ NEW: sirf procurement_pending items queue mein aayenge
          // approved_pending_issue = stock check hoga Issue Material se
          // issued = already done
          const itemStatus = String(item.item_status || "").trim();
          if (itemStatus === "issued" || itemStatus === "approved_pending_issue") continue;
          // procurement_pending + "" (legacy) + "partially_issued" remaining → queue mein dikhao

          // Resolve category from in-memory master map
          const masterItem = itemsMasterMap[item.item_id] ||
                             itemsMasterMap[(item.item_code || "").trim()] ||
                             itemsMasterMap[`name:${(item.item_name || "").toLowerCase().trim()}`] ||
                             null;

          // NEW — is_active check added before category filter
          if (masterItem && masterItem.is_active === false) continue;

          // ✅ FIX: case-insensitive category — item.category UPPERCASE ho sakti hai
          const itemCategory = String(
            masterItem?.category || item.category || ""
          ).trim().toLowerCase();

          // Only MATERIAL + CONSUMABLE
          // ✅ MRF_ALLOWED_CATEGORIES se match karo — sab valid categories
const ALLOWED = [
  "material", "consumable",
  // legacy categories — Fix General Categories ke baad khatam ho jaayenge
  "general", "copper", "electrical", "refrigerant", "ducting",
  "hardware", "consumables", "spares", "safety", "testing",
  "vrf/vrv", "chiller", "split ac",
];
          if (!ALLOWED.includes(itemCategory)) {
            console.log("PROCUREMENT SKIPPED:", item.item_name, itemCategory);
            continue;
          }

          // Resolve item_code from in-memory inventory map (no extra query)
          let itemCode = item.item_code || item.code || "";
          if (!itemCode && item.item_id) {
            const invItem = inventoryMap[item.item_id] || null;
            if (invItem) itemCode = invItem.item_code || "";
          }

          // Skip fully issued
          const approvedQty  = Number(item.approved_qty || item.qty || 0);
          const issuedQty    = Number(item.issued_qty || 0);
          const remainingQty = Math.max(0, approvedQty - issuedQty);
          if (remainingQty <= 0) continue;

          const procurementRowId = item.is_custom_item
            ? `custom_${docSnap.id}_${itemIndex}`
            : `${item.item_id}_${item.unit}`;

          // preferred vendor — from master item or MRF item
          const preferredVendorId   = masterItem?.preferred_vendor_id   || item.preferred_vendor_id   || "";
          const preferredVendorName = masterItem?.preferred_vendor_name || item.preferred_vendor_name || "";

          rows.push({
            procurement_row_id:    procurementRowId,
            mrf_id:                docSnap.id,
            site_id:               data.site_id    || "",
            company_id:            data.company_id || "",
            site_name:             data.site_name  || "",
            item_id:               item.item_id    || "",
            item_index:            itemIndex,
            item_name:             item.item_name  || "",
            item_code:             itemCode,
            qty:                   approvedQty,
            approved_qty:          approvedQty,
            issued_qty:            issuedQty,
            remaining_qty:         remainingQty,
            unit:                  item.unit       || "",
            purchase_processed:    item.purchase_processed || false,
            purchase_status:       item.purchase_status    || "",
            purchase_batch_id:     item.purchase_batch_id  || "",
            category:              itemCategory,
            procurement_type:      procurementType,
            is_custom_item:        item.is_custom_item || false,
            preferred_vendor_id:   preferredVendorId,
            preferred_vendor_name: preferredVendorName,
          });
        }
      }

      setQueueItems(rows);
      setVendorsList(vendorsList);

      // Auto-fill preferred vendors
      const autoVendors = {};
      rows.forEach(row => {
        if (row.preferred_vendor_id) {
          autoVendors[row.procurement_row_id] = {
            vendor_id:   row.preferred_vendor_id,
            vendor_name: row.preferred_vendor_name,
          };
        }
      });
      setSelectedVendors(autoVendors);

    } catch (error) {
      console.error(
        "PROCUREMENT QUEUE ERROR:",
        error
      );

    } finally {

      setLoading(false);
    }
  };

    // ============================================
// TOGGLE SELECT
// ============================================

const toggleSelect = (
  procurementRowId
) => {

  setSelectedItems(
    (prev) => ({

      ...prev,

      [procurementRowId]:
        !prev[procurementRowId]
    })
  );
};

const toggleSelectAll = () => {

  const allSelected =
    queueItems.every(
  (row) =>
    selectedItems[
      row.procurement_row_id
    ]
);

  if (allSelected) {

    setSelectedItems({});
    return;
  }

  const updated = {};

  queueItems.forEach(
    (row) => {

      updated[
        row.procurement_row_id
      ] = true;
    }
  );

  setSelectedItems(updated);
};

// ============================================
// GENERATE PROCUREMENT BATCH
// ============================================

const generatePurchaseBatch =
  async () => {

    try {

      if (generatingBatch) {
        return;
      }

      setGeneratingBatch(true);

      const selectedRows =
        queueItems.filter(
          (row) =>
            selectedItems[
              row.procurement_row_id
            ]
        );

      // =====================================
      // VALIDATE SELECTION
      // =====================================

      if (
        selectedRows.length === 0
      ) {

        alert(
          "Select items first"
        );

        return;
      }

      // =====================================
      // VENDOR VALIDATION — har selected item ka vendor mandatory
      // =====================================
      const missingVendorItems = selectedRows.filter(
        row => !selectedVendors[row.procurement_row_id]?.vendor_id
      );
      if (missingVendorItems.length > 0) {
        alert(
          `⚠️ Vendor assign nahi hai:\n${missingVendorItems.map(r => `• ${r.item_name}`).join("\n")}\n\nPehle vendor select karo.`
        );
        return;
      }

      // =====================================
      // DUPLICATE VALIDATION
      // =====================================

      for (const row of selectedRows) {

        const originalMRF =
          materialRequestDocs.find(
            (d) =>
              d.id === row.mrf_id
          );

        if (!originalMRF) {
          continue;
        }

        const mrfData =
          originalMRF.data();

        const originalItem =
          mrfData.items?.[
            row.item_index
          ];

        if (!originalItem) {
          continue;
        }

        if (

          originalItem.purchase_status ===
            "batched" ||

          originalItem.purchase_status ===
            "po_created"

        ) {

          alert(
            `${row.item_name} already processed`
          );

          return;
        }
      }

      // =====================================
      // CREATE FIRESTORE BATCH
      // =====================================

      const firestoreBatch =
        writeBatch(db);

      const batchId =
        `PB-${Date.now()}`;

      // =====================================
// PURCHASE REQUEST NUMBER
// =====================================

const purchaseRequestCollection =
  collection(
    db,
    "purchase_requests"
  );

// Company-scoped filter added — getCountFromServer() with NO where()
// clause can never be proven safe by the fallback security rule's
// sameCompany() check (which needs resource.data.company_id to read),
// so Firestore rejects the unfiltered count outright with
// permission-denied. This isn't a rules gap to patch — an unfiltered
// cross-tenant count is exactly what multi-tenant isolation should
// block. The real fix is scoping the query itself, same discipline as
// every other collection-wide query in this file (itemsMasterMap,
// inventoryMap, vendorsMap above all filter on company_id).
// NOTE: this count is now used ONLY as a one-time seed for the atomic
// system_counters doc below — it is never read as the live sequence
// source anymore (that was the non-atomic race-condition bug, same
// class as D-261/D-262).
const purchaseRequestCount =
  await getCountFromServer(
    query(
      purchaseRequestCollection,
      where("company_id", "==", userData.company_id || "")
    )
  );

const financialYear =
  "26-27";

// =====================================
// ATOMIC PR NUMBER — system_counters + runTransaction
// Same pattern as PO/ADJ/VRT/Material-Stage numbering (CORE_RULES §14).
// Counter doc is company-scoped (system_counters/pr_{company_id}) since
// PR numbering itself is company-scoped — unlike the global PO/{year}
// counter. First call for a company seeds from purchaseRequestCount
// (above); every call after that reads the real last_number.
// =====================================
const getNextPurchaseRequestSequence = async () => {
  const counterRef = doc(
    db,
    "system_counters",
    `pr_${userData.company_id || ""}`
  );

  return runTransaction(db, async (transaction) => {
    const counterSnap = await transaction.get(counterRef);

    const current = counterSnap.exists()
      ? Number(counterSnap.data().last_number || 0)
      : purchaseRequestCount.data().count; // one-time seed only

    const next = current + 1;

    transaction.set(
      counterRef,
      {
        last_number: next,
        updated_at: serverTimestamp(),
      },
      { merge: true }
    );

    return next;
  });
};

// =====================================
      // VENDOR-WISE GROUP → ALAG ALAG PR
      // =====================================

      // Group selected rows by vendor_id
      const vendorGroups = {};
      for (const row of selectedRows) {
        const v = selectedVendors[row.procurement_row_id];
        const key = v.vendor_id;
        if (!vendorGroups[key]) {
          vendorGroups[key] = {
            vendor_id:   v.vendor_id,
            vendor_name: v.vendor_name,
            rows:        [],
          };
        }
        vendorGroups[key].rows.push(row);
      }

      // Track first PR ref for navigate
      let firstPurchaseRequestRef = null;

      for (const group of Object.values(vendorGroups)) {

        const prSequence = await getNextPurchaseRequestSequence();

        const groupPRNo = `PR-${financialYear}-${String(prSequence).padStart(6, "0")}`;
        const groupPRRef = doc(purchaseRequestCollection);

        if (!firstPurchaseRequestRef) firstPurchaseRequestRef = groupPRRef;

        const groupUniqueSites = [...new Set(group.rows.map(r => r.site_name))];
        const groupUniqueMRFs  = [...new Set(group.rows.map(r => r.mrf_id))];

        firestoreBatch.set(groupPRRef, {
          company_id:           userData.company_id || "",
          purchase_request_id:  groupPRRef.id,
          purchase_request_no:  groupPRNo,
          purchase_batch_id:    batchId,
          vendor_id:            group.vendor_id,
          vendor_name:          group.vendor_name,
          procurement_status:   "pending_vendor",
          status:               "pending",
          created_at:           serverTimestamp(),
          created_by_name:      userData.name || "Manager",
          total_items:          group.rows.length,
          total_sites:          groupUniqueSites.length,
          total_mrfs:           groupUniqueMRFs.length,
          linked_site_names:    groupUniqueSites,
          source_mrf_ids:       groupUniqueMRFs,
          items:                group.rows,
        });
      }

      // purchaseRequestRef = firstPurchaseRequestRef (navigate ke liye)
      const purchaseRequestRef = firstPurchaseRequestRef;

      // =====================================
      // UPDATE ORIGINAL MRF ITEMS
      // =====================================

      for (const row of selectedRows) {

        const mrfRef =
          doc(
            db,
            "material_requests",
            row.mrf_id
          );

        const originalMRF =
          materialRequestDocs.find(
            (d) =>
              d.id === row.mrf_id
          );

        if (!originalMRF) {
          continue;
        }

        const mrfData =
          originalMRF.data();

        const updatedItems =
          (mrfData.items || []).map(
            (
              item,
              index
            ) => {

              if (
                index ===
                row.item_index
              ) {

                return {

                  ...item,

                  purchase_status:
                    "batched",

                  purchase_request_id:
                    purchaseRequestRef.id,

                  purchase_batch_id:
                    batchId,

                  purchase_batched_at:
                    new Date()
                };
              }

              return item;
            }
          );

        firestoreBatch.update(
          mrfRef,
          {

            items:
              updatedItems,

            updated_at:
              serverTimestamp()
          }
        );
      }

      // =====================================
      // COMMIT
      // =====================================

      await firestoreBatch.commit();

      // =====================================
      // CLEAR SELECTION
      // =====================================

      setSelectedItems({});

      // =====================================
      // REFRESH QUEUE
      // =====================================

      await fetchQueue();

      // =====================================
      // REDIRECT
      // =====================================

      navigate(
        "/purchase-list",
        {
          state: {
            purchase_request_id:
              purchaseRequestRef.id
          }
        }
      );

    } catch (error) {

      console.error(
        "PURCHASE BATCH ERROR:",
        error
      );

      alert(
        "Batch Creation Failed"
      );

    } finally {

      setGeneratingBatch(false);
    }
};


// ============================================
// GENERATE PURCHASE ORDER
// ============================================

// generatePurchaseOrder removed — PO creation happens in Purchase List

useEffect(() => {
  fetchQueue();
// eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

  // ============================================
  // UI
  // ============================================

  return (

  <div className="p-5 pb-24 bg-gradient-to-br from-slate-100 via-gray-100 to-slate-200">

    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">

      <div>

        <h1 className="text-3xl font-bold text-slate-800">
          Procurement Queue
        </h1>

        <p className="text-sm text-gray-500 mt-1">
          Approved purchase items waiting for procurement
        </p>

      </div>

      <div className="bg-white shadow-sm border border-gray-200 rounded-2xl px-5 py-3">

        <div className="text-xs text-gray-500 uppercase">
          Queue Items
        </div>

        <div className="text-2xl font-bold text-slate-700">
          {filteredQueueItems.length}
        </div>

      </div>

    </div>

    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-4">

        <div>

          <h2 className="text-lg font-semibold text-slate-700">
            Purchase Procurement Queue
          </h2>

          <p className="text-sm text-gray-500">
            Generate procurement batches for approved MRF items
          </p>

        </div>

        <div className="flex items-center gap-3">

  {/* ✅ Purchase Orders shortcut */}
  <button
    onClick={() => navigate("/purchase-orders")}
    className="px-4 py-3 rounded-2xl bg-violet-100 hover:bg-violet-200 text-violet-700 font-semibold transition text-sm"
  >
    🛒 Purchase Orders
  </button>

  <button

    onClick={toggleSelectAll}

    className="px-4 py-3 rounded-2xl bg-slate-200 hover:bg-slate-300 text-slate-700 font-semibold transition"

  >

    {
  filteredQueueItems.every(
    (row) =>
      selectedItems[
        row.procurement_row_id
      ]
  )
    ? `Deselect Visible (${filteredQueueItems.length})`
    : `Select Visible Items (${filteredQueueItems.length})`
}

  </button>

  <div className="flex gap-3">

    <button
      disabled={generatingBatch}
      onClick={generatePurchaseBatch}
      className="
        px-6 py-3
        rounded-2xl
        bg-gradient-to-r
        from-cyan-500
        to-blue-600
        text-white
        font-semibold
        shadow-lg
      "
    >
      {generatingBatch ? "Generating..." : "Generate Purchase Batch"}
    </button>

  </div>

</div>

      </div>

      <div className="overflow-x-auto">

    <table className="w-full min-w-[760px] text-sm">

          <thead className="sticky top-0 z-10 bg-slate-900 text-white text-xs">

            <tr>

              <th className="text-left px-2 py-3">
                Select
              </th>

              <th className="text-left px-2 py-3">
                Site
              </th>

              <th className="text-left px-2 py-3">
                Item
              </th>

              <th className="text-left px-2 py-3">
                Code
              </th>

              <th className="text-left px-2 py-3">
                Vendor *
              </th>

              <th className="text-left px-2 py-3">
  Appr.
</th>

<th className="text-left px-2 py-3">
  Issued
</th>

<th className="text-left px-2 py-3">
  Remaining
</th>

<th className="text-left px-2 py-3">
  Status
</th>

<th className="text-left px-2 py-3">
  Unit
</th>

            </tr>

          </thead>

          <tbody>

            {queueItems.length === 0 ? (

              <tr>

                <td
                  colSpan="10"
                  className="text-center py-16 text-gray-500"
                >

                  <div className="flex flex-col items-center gap-3">

                    <div className="w-16 h-16 rounded-full bg-slate-100 flex items-center justify-center text-2xl">
                      📦
                    </div>

                    <div className="text-lg font-semibold">
                      No Procurement Pending
                    </div>

                    <div className="text-sm text-gray-400">
                      All approved items are already processed
                    </div>

                  </div>

                </td>

              </tr>

            ) : (

              filteredQueueItems.map(
  (
    row,
    index
  ) => (

    <tr
      key={
  row.procurement_row_id
}
      className="border-b border-gray-100 hover:bg-cyan-50/40 transition"
    >

      <td className="px-5 py-4">

        {
  row.purchase_processed ||

  row.purchase_status ===
    "batched" ||

  row.purchase_status ===
    "po_created"

    ? (

      <span className="text-[10px] px-2 py-1 rounded-full bg-slate-200 text-slate-600 font-bold uppercase">

        Locked

      </span>

    ) : (

      <input
        type="checkbox"

        checked={
          !!selectedItems[
            row.procurement_row_id
          ]
        }

        onChange={() =>
          toggleSelect(
            row.procurement_row_id
          )
        }

        className="w-5 h-5 accent-cyan-600"
      />
    )
}

      </td>

      <td className="px-5 py-4 font-medium text-slate-700">
        {row.site_name}
      </td>

      <td className="px-5 py-4">

        <div className="flex flex-col gap-1">

          <div>
            {row.item_name}
          </div>

          {row.is_custom_item && (

            <span className="inline-flex items-center gap-2 w-fit px-3 py-1 rounded-full bg-gradient-to-r from-orange-500 to-amber-500 text-white text-[10px] font-semibold uppercase tracking-wide shadow-sm">

  <span className="w-2 h-2 rounded-full bg-white"></span>

  Custom Procurement

</span>

          )}

        </div>

      </td>

      <td className="px-5 py-4">

  {row.item_code ? (

    <span className="font-medium text-slate-700">
      {row.item_code}
    </span>

  ) : row.is_custom_item ? (

    <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-gradient-to-r from-violet-600 to-fuchsia-600 text-white text-[10px] font-bold uppercase tracking-wider shadow-sm">

      <span className="w-2 h-2 rounded-full bg-white"></span>

      Custom

    </span>

  ) : (

    <span className="px-2 py-1 rounded-full bg-red-100 text-red-700 text-xs font-bold">
      NO CODE
    </span>

  )}

</td>

      {/* VENDOR DROPDOWN */}
      <td className="px-5 py-4">
        {row.purchase_processed ||
         row.purchase_status === "batched" ||
         row.purchase_status === "po_created" ? (
          <span className="text-sm text-slate-500">
            {selectedVendors[row.procurement_row_id]?.vendor_name || "—"}
          </span>
        ) : (
          <select
            value={selectedVendors[row.procurement_row_id]?.vendor_id || ""}
            onChange={e => {
              const v = vendorsList.find(v => v.id === e.target.value);
              setSelectedVendors(prev => ({
                ...prev,
                [row.procurement_row_id]: v
                  ? { vendor_id: v.id, vendor_name: v.vendor_name || v.name || "" }
                  : { vendor_id: "", vendor_name: "" },
              }));
            }}
            className={`border rounded-lg px-2 py-1 text-sm w-40 ${
              selectedItems[row.procurement_row_id] &&
              !selectedVendors[row.procurement_row_id]?.vendor_id
                ? "border-red-400 bg-red-50"
                : "border-slate-200"
            }`}
          >
            <option value="">— Select Vendor —</option>
            {vendorsList.map(v => (
              <option key={v.id} value={v.id}>
                {v.vendor_name || v.name || v.id}
              </option>
            ))}
          </select>
        )}
      </td>

                    <td className="px-5 py-4 font-semibold text-slate-700">
  {row.total_approved || 0}
</td>

<td className="px-5 py-4 text-amber-600 font-semibold">
  {row.total_issued || 0}
</td>

<td className="px-5 py-4">

  <div className="flex items-center gap-2">

    <div className="font-bold text-red-600">
  {row.total_remaining}
</div>

{(row.total_remaining > 0) && (
      <span className="text-[10px] px-2 py-1 rounded-full bg-red-100 text-red-700 font-semibold">
        SHORTAGE
      </span>
    )}

  </div>

</td>

<td className="px-5 py-4">

  {row.purchase_processed ? (

    <span className="px-3 py-1 rounded-full bg-emerald-100 text-emerald-700 text-xs font-bold">
      PROCURED
    </span>

  ) : (

    <span className="px-3 py-1 rounded-full bg-amber-100 text-amber-700 text-xs font-bold">
      PENDING
    </span>

  )}

</td>

<td className="px-5 py-4">
  {row.unit}
</td>

                  </tr>
                )
              )

            )}

          </tbody>

        </table>

      </div>

  </div>
);
}